import { GetterTree } from 'vuex';

import { IState } from '@app/store';
import { Getter } from '@store/StoreUtil';
import {
    MarketFiltersState,
    TournamentId,
} from '@store/modules/ui/sportOffer/marketFilters/types';

type MarketFiltersGetter<T> = Getter<MarketFiltersState, IState, T>;

export interface MarketFiltersGetters extends GetterTree<MarketFiltersState, IState> {
    areMarketsLoading: MarketFiltersGetter<(id: TournamentId) => boolean>;
    areMarketsInitialized: MarketFiltersGetter<(id: TournamentId) => boolean>;
}

const getters: MarketFiltersGetters = {
    areMarketsLoading(state: MarketFiltersState) {
        return (id) => !!state.loading[id];
    },
    areMarketsInitialized(state: MarketFiltersState) {
        return (id) => !!state.initialized[id];
    },
};

export default getters;
